import { useRouteMatch } from 'react-router-dom';
import { ROUTER_ENTITY_TO_ROUTE_PATH_MAP } from '../../../../constants';

type PlaceParams = {
  placeId?: string;
};

export const useSelectedPlaceId = (): number | undefined => {
  // Using `useRouteMatch()` instead of `useParams()` since we're not always inside the Place <Router>
  const match = useRouteMatch<PlaceParams>(
    ROUTER_ENTITY_TO_ROUTE_PATH_MAP.place,
  );
  const placeIdStr = match?.params.placeId;

  return placeIdStr ? parseInt(placeIdStr, 10) : undefined;
};
